export const GET_CR_FILE = "GET_CR_FILE";
export const GET_CR_FILE_SUCCESS = "GET_CR_FILE_SUCCESS";
export const GET_CR_FILE_ERROR = "GET_CR_FILE_ERROR";